import { render, staticRenderFns } from "./BottomLeftChart2.vue?vue&type=template&id=06d6c2c0&"
import script from "./BottomLeftChart2.vue?vue&type=script&lang=js&"
export * from "./BottomLeftChart2.vue?vue&type=script&lang=js&"
import style0 from "./BottomLeftChart2.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports